// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clinical-main:has(.fin),
.clinical-main__scroll:has(.fin) {
  background: #f8fafc;
}

.clinical-main__scroll:has(.fin) {
  display: flex;
  flex-direction: column;
}

.clinical-main__scroll:has(.fin) > div {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  min-height: 100%;
  background: #f8fafc;
}

.fin {
  box-sizing: border-box;
  flex: 1 0 auto;
  min-height: 100%;
  padding: 20px 24px 28px;
  background: #f8fafc;
  color: #0f172a;
}

.fin * {
  box-sizing: border-box;
}

.fin-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.fin-crumb {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 6px;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
}

.fin-crumb a {
  color: #64748b;
  text-decoration: none;
}

.fin-crumb a:hover {
  color: #0284c7;
}

.fin-crumb .is-current {
  color: #0f172a;
  font-weight: 600;
}

.fin-header h1 {
  margin: 0;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.fin-facts {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 16px;
  margin: 0 0 16px;
  padding: 16px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.fin-facts > div {
  min-width: 0;
}

.fin-facts dt {
  margin: 0;
  color: #64748b;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.04em;
  line-height: 14px;
  text-transform: uppercase;
}

.fin-facts dd {
  margin: 2px 0 0;
  color: #0f172a;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fin-facts dd.is-strong {
  font-weight: 600;
}

.fin-facts dd.is-tabular {
  font-variant-numeric: tabular-nums;
}

@media (max-width: 1100px) {
  .fin-facts {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .fin-facts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.fin-add,
.fin-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
}

.fin-add {
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #334155;
}

.fin-add:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}

.fin-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.fin-table {
  width: 100%;
  border-collapse: collapse;
}

.fin-table th {
  padding: 10px 16px;
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-align: start;
  text-transform: uppercase;
  border-bottom: 1px solid #e2e8f0;
}

.fin-table td {
  padding: 14px 16px;
  font-size: 14px;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

.fin-table th.is-end,
.fin-table td.is-end {
  text-align: end;
}

.fin-name {
  font-weight: 600;
}

.fin-num {
  font-variant-numeric: tabular-nums;
  font-weight: 500;
  color: #334155;
}

.fin-remainder {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 4px;
  background: #f1f5f9;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  font-variant-numeric: tabular-nums;
}

.fin-empty {
  color: #64748b;
  text-align: center;
}

.fin-link {
  border: 0;
  background: transparent;
  padding: 0;
  color: #0ea5e9;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
}

.fin-link.is-remove {
  color: #e11d48;
}

.fin-settlement-row td {
  padding: 0 16px 16px;
  border-bottom: 1px solid #f1f5f9;
  background: #ffffff;
}

.fin-settlement {
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}

.fin-settlement h3 {
  margin: 0 0 12px;
  font-size: 14px;
  font-weight: 600;
}

.fin-settle {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.fin-settle-pair {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.fin-quantity {
  max-width: 280px;
}

.fin .ant-form-item {
  margin-bottom: 0;
}

.fin .ant-form-item-label {
  padding-bottom: 4px;
}

.fin .ant-form-item-label > label {
  color: #334155;
  font-size: 13px;
  font-weight: 500;
  height: auto;
}

.fin-used .ant-form-item-control {
  max-width: 112px;
}

.fin .ant-form-item-control-input {
  min-height: 36px !important;
}

.fin .ant-select,
.fin .ant-input-number,
.fin .ant-input-number-affix-wrapper,
.fin .ant-input-number-group-wrapper {
  width: 100% !important;
}

.fin .ant-select .ant-select-selector,
.fin .ant-input-number-affix-wrapper,
.fin .ant-input-number {
  box-sizing: border-box;
  height: 36px !important;
  border-radius: 8px !important;
  border: 1px solid #cbd5e1 !important;
  background: #ffffff !important;
  box-shadow: none !important;
  font-size: 14px !important;
}

.fin .ant-input-number-affix-wrapper {
  display: inline-flex !important;
  align-items: center;
  padding: 0 12px !important;
}

.fin .ant-input-number-affix-wrapper .ant-input-number {
  flex: 1 1 auto;
  width: 100% !important;
  height: 34px !important;
  min-height: 0 !important;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.fin .ant-input-number-handler-wrap {
  display: none;
}

.fin .ant-select .ant-select-selection-item,
.fin .ant-select .ant-select-selection-placeholder,
.fin .ant-input-number-input {
  line-height: 34px !important;
  height: 34px !important;
  font-size: 14px !important;
}

.fin .ant-input-number-input {
  padding: 0 !important;
}

.fin .ant-select-focused .ant-select-selector,
.fin .ant-input-number-focused,
.fin .ant-input-number-affix-wrapper-focused,
.fin .ant-input-number-affix-wrapper:focus-within {
  border-color: #0ea5e9 !important;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15) !important;
}

.fin .ant-form-item-has-error .ant-select .ant-select-selector,
.fin .ant-form-item-has-error .ant-input-number-affix-wrapper,
.fin .ant-form-item-has-error .ant-input-number {
  border-color: #f43f5e !important;
}

.fin-submit {
  margin-top: 16px;
  border: 0;
  background: #0ea5e9;
  color: #ffffff;
}

.fin-submit:hover {
  background: #0284c7;
}

@media (max-width: 720px) {
  .fin-header,
  .fin-settle-pair {
    flex-direction: column;
    grid-template-columns: 1fr;
  }

  .fin-quantity {
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/FinishAppointment/style.css"],"names":[],"mappings":"AAAA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;EACpC,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,4BAA4B;EAC5B,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;EAIE,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;;IAEE,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".clinical-main:has(.fin),\n.clinical-main__scroll:has(.fin) {\n  background: #f8fafc;\n}\n\n.clinical-main__scroll:has(.fin) {\n  display: flex;\n  flex-direction: column;\n}\n\n.clinical-main__scroll:has(.fin) > div {\n  display: flex;\n  flex: 1 0 auto;\n  flex-direction: column;\n  min-height: 100%;\n  background: #f8fafc;\n}\n\n.fin {\n  box-sizing: border-box;\n  flex: 1 0 auto;\n  min-height: 100%;\n  padding: 20px 24px 28px;\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n.fin * {\n  box-sizing: border-box;\n}\n\n.fin-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.fin-crumb {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 6px;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.fin-crumb a {\n  color: #64748b;\n  text-decoration: none;\n}\n\n.fin-crumb a:hover {\n  color: #0284c7;\n}\n\n.fin-crumb .is-current {\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.fin-header h1 {\n  margin: 0;\n  font-size: 24px;\n  line-height: 1.2;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.fin-facts {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 16px;\n  margin: 0 0 16px;\n  padding: 16px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n}\n\n.fin-facts > div {\n  min-width: 0;\n}\n\n.fin-facts dt {\n  margin: 0;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 500;\n  letter-spacing: 0.04em;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.fin-facts dd {\n  margin: 2px 0 0;\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 18px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.fin-facts dd.is-strong {\n  font-weight: 600;\n}\n\n.fin-facts dd.is-tabular {\n  font-variant-numeric: tabular-nums;\n}\n\n@media (max-width: 1100px) {\n  .fin-facts {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 640px) {\n  .fin-facts {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.fin-add,\n.fin-submit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.fin-add {\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #334155;\n}\n\n.fin-add:hover {\n  border-color: #cbd5e1;\n  background: #f8fafc;\n}\n\n.fin-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.fin-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.fin-table th {\n  padding: 10px 16px;\n  background: #f8fafc;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-align: start;\n  text-transform: uppercase;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.fin-table td {\n  padding: 14px 16px;\n  font-size: 14px;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: middle;\n}\n\n.fin-table th.is-end,\n.fin-table td.is-end {\n  text-align: end;\n}\n\n.fin-name {\n  font-weight: 600;\n}\n\n.fin-num {\n  font-variant-numeric: tabular-nums;\n  font-weight: 500;\n  color: #334155;\n}\n\n.fin-remainder {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: #f1f5f9;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  font-variant-numeric: tabular-nums;\n}\n\n.fin-empty {\n  color: #64748b;\n  text-align: center;\n}\n\n.fin-link {\n  border: 0;\n  background: transparent;\n  padding: 0;\n  color: #0ea5e9;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.fin-link.is-remove {\n  color: #e11d48;\n}\n\n.fin-settlement-row td {\n  padding: 0 16px 16px;\n  border-bottom: 1px solid #f1f5f9;\n  background: #ffffff;\n}\n\n.fin-settlement {\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n\n.fin-settlement h3 {\n  margin: 0 0 12px;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.fin-settle {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.fin-settle-pair {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.fin-quantity {\n  max-width: 280px;\n}\n\n.fin .ant-form-item {\n  margin-bottom: 0;\n}\n\n.fin .ant-form-item-label {\n  padding-bottom: 4px;\n}\n\n.fin .ant-form-item-label > label {\n  color: #334155;\n  font-size: 13px;\n  font-weight: 500;\n  height: auto;\n}\n\n.fin-used .ant-form-item-control {\n  max-width: 112px;\n}\n\n.fin .ant-form-item-control-input {\n  min-height: 36px !important;\n}\n\n.fin .ant-select,\n.fin .ant-input-number,\n.fin .ant-input-number-affix-wrapper,\n.fin .ant-input-number-group-wrapper {\n  width: 100% !important;\n}\n\n.fin .ant-select .ant-select-selector,\n.fin .ant-input-number-affix-wrapper,\n.fin .ant-input-number {\n  box-sizing: border-box;\n  height: 36px !important;\n  border-radius: 8px !important;\n  border: 1px solid #cbd5e1 !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n  font-size: 14px !important;\n}\n\n.fin .ant-input-number-affix-wrapper {\n  display: inline-flex !important;\n  align-items: center;\n  padding: 0 12px !important;\n}\n\n.fin .ant-input-number-affix-wrapper .ant-input-number {\n  flex: 1 1 auto;\n  width: 100% !important;\n  height: 34px !important;\n  min-height: 0 !important;\n  border: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.fin .ant-input-number-handler-wrap {\n  display: none;\n}\n\n.fin .ant-select .ant-select-selection-item,\n.fin .ant-select .ant-select-selection-placeholder,\n.fin .ant-input-number-input {\n  line-height: 34px !important;\n  height: 34px !important;\n  font-size: 14px !important;\n}\n\n.fin .ant-input-number-input {\n  padding: 0 !important;\n}\n\n.fin .ant-select-focused .ant-select-selector,\n.fin .ant-input-number-focused,\n.fin .ant-input-number-affix-wrapper-focused,\n.fin .ant-input-number-affix-wrapper:focus-within {\n  border-color: #0ea5e9 !important;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15) !important;\n}\n\n.fin .ant-form-item-has-error .ant-select .ant-select-selector,\n.fin .ant-form-item-has-error .ant-input-number-affix-wrapper,\n.fin .ant-form-item-has-error .ant-input-number {\n  border-color: #f43f5e !important;\n}\n\n.fin-submit {\n  margin-top: 16px;\n  border: 0;\n  background: #0ea5e9;\n  color: #ffffff;\n}\n\n.fin-submit:hover {\n  background: #0284c7;\n}\n\n@media (max-width: 720px) {\n  .fin-header,\n  .fin-settle-pair {\n    flex-direction: column;\n    grid-template-columns: 1fr;\n  }\n\n  .fin-quantity {\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
